<script setup lang="js">
import { computed, onMounted, ref } from 'vue';
import { useProjectStore } from '@/stores/project.store';
import { useInputFieldStore } from '@/stores/inputField.store';
import { useRouteParams } from '@vueuse/router';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';
import BasicToggleSwitch from '@/components/toggle-switch.vue';
import { useRegistryStore } from '@/stores/registry.store';
import Multiselect from 'vue-multiselect';

const inputFieldStore = useInputFieldStore();
const projectStore = useProjectStore();
const registryStore = useRegistryStore();

const projectId = useRouteParams('projectId');
const bpId = useRouteParams('bpId');
const nodeId = useRouteParams('nodeId');
const inputTableId = useRouteParams('inputTableId');
const { closeModal } = useModal();
const { project } = storeToRefs(projectStore);
const { typeList, createColumnRequest } = storeToRefs(inputFieldStore);
const { regTables } = storeToRefs(registryStore);

const title = ref({});
const type = ref("");
const required = ref(false);
const selectedRegTable = ref(null);
const title_columns = ref({});
const settings = ref(null);

const filteredRegTables = computed(() => regTables.value.filter((registry) => registry.stable));

onMounted(() => {
  if (!regTables.value.length) {
    registryStore.getRegTableList(projectId.value);
  }
  inputFieldStore.clearRequestVariables();
  if (!project.locales) {
    projectStore.getProject(projectId.value);
  }
});

function createColumn() {
  if (type.value === 'identificator' && selectedRegTable.value) {
    settings.value = {
      reg_table_id: selectedRegTable.value.id,
      reg_version: selectedRegTable.value.last_version,
      title_columns: title_columns.value
    };
  }

  inputFieldStore.createColumn(projectId.value, bpId.value, nodeId.value, inputTableId.value, title.value, type.value, required.value, settings.value)
    .then(() => {
      closeModal();
    });
}
function isErrorField(fieldName) {
  if (createColumnRequest.value.error?.errors) {
    return createColumnRequest.value.error.errors[fieldName] || false;
  }
}
function isNotFieldError() {
  if (!(createColumnRequest.value.error?.errors)) {
    return createColumnRequest.value.error;
  }
}
</script>

<template>
  <ModalTemplateSide @submit="createColumn" :disableButtons="createColumnRequest.isLoading">
    <template v-slot:title>Добавить столбец в таблицу</template>
    <template v-slot:body>
      <div class="mt-3" v-for="locale in project.locales" :key="locale.id">
        <label class="form-label">Наименование ({{ locale.name }})</label>
        <input type="text" v-model="title[locale.id]" class="form-control"
          :class="{ 'error': isErrorField('title') }" />
      </div>
      <p v-if="isErrorField('title')" class="error-mesage">
        <span v-for="error in isErrorField('title')">{{ error }}</span>
      </p>
      <div class="mt-3">
        <label class="form-label">Тип</label>
        <select v-model="type" class="form-select" :class="{ 'error': isErrorField('type') }">
          <option v-for="typeKey in Object.keys(typeList)" :key="typeKey" :value="typeKey">
            {{ typeList[typeKey] }}
          </option>
        </select>
        <p v-if="isErrorField('type')" class="error-mesage">
          <span v-for="error in isErrorField('type')">{{ error }}</span>
        </p>
      </div>

      <div v-if="type === 'identificator'">

        <div class="mt-3">
          <label class="form-label">Реестр</label>
          <Multiselect v-model="selectedRegTable" :options="filteredRegTables" placeholder="Выбрать..."
            :multiple="false" label="id" track-by="id" class="multiselect-style"
            :class="{ error: isErrorField('selectedRegTable') }" />
          <p v-if="isErrorField('reg_table_id')" class="error-mesage">
            <span v-for="error in isErrorField('reg_table_id')" :key="error">{{ error }}</span>
          </p>
        </div>

        <template v-if="selectedRegTable">
          <div class="mt-3" v-for="locale in project.locales" :key="locale.id">
            <label class="form-label">Колонка({{ locale.name }})</label>
            <select v-model="title_columns[locale.id]" class="form-select"
              :class="{ error: isErrorField('title_columns') }">
              <option v-for="column in selectedRegTable.columns" :key="column.id" :value="String(column.id)">
                {{ column.name }}
              </option>
            </select>
          </div>
        </template>

      </div>

      <div class="mt-3 d-flex align-items-center justify-content-between">
        <label class="form-label">Обязательность</label>
        <basic-toggle-switch v-model="required" />
      </div>
      <p v-if="isNotFieldError()" class="error-mesage">
        {{ isNotFieldError() }}
      </p>
    </template>
    <template v-slot:submit>Создать</template>
  </ModalTemplateSide>
</template>
